<template>
  <div class="uk-container">
    <div v-if="inactive">
      <InactiveInfo :member="inactiveMember" />
    </div>
    <div v-else>
      <table class="uk-table">
        <thead>
          <th>#</th>
          <th>Book Number</th>
          <th>Registered Date</th>
          <th>Classifications</th>
          <th>Last Booking Date</th>
          <th>Refusals</th>
          <th>Absentees</th>
        </thead>
        <tbody>
          <template v-for="(member, index) in members.slice((currentPage-1)*rowsPerPage, ((currentPage-1)*rowsPerPage+rowsPerPage))">
            <TableRow :member="member" :index="index+10*(currentPage-1)" v-bind:key="index" :id="'row-'+(index+1)"/>
          </template>
        </tbody>
      </table>
      <div class="pagination-buttons uk-pagination uk-flex-center">
      <span v-if="currentPage !== 1" >
        <a @click="currentPage-=1">&larr;</a>
      </span>
      <span v-for="(i,index) in pagination(currentPage, numPages)" v-bind:key="'nav-button-'+index">
        <a v-if="i !== '...'" @click="currentPage = i">{{i}}</a>
        <span v-else>...</span>
      </span>
      <span v-if="currentPage !== numPages" >
        <a @click="currentPage+=1">&rarr;</a>
      </span>
    </div>
    </div>
  </div>
</template>

<script>
import MembersApi from "@/utils/api/members";
import TableRow from "./member_queue_row.vue";
import InactiveInfo from "./member_inactive";

export default {
  name: "MemberQueue",
  components: {
    TableRow,
    InactiveInfo
  },
  data() {
    return {
      loaded: false,
      inactive: false,
      members: [],
      activeMemberIndex: 0,
      inactiveMember: {},
      rowsPerPage: 10,
      numberRange: 2,
      currentPage: 1,
      numPages: 1
    };
  },
  beforeRouteEnter(to, from, next) {
    MembersApi.getMembersRestricted(to.query.bookNum)
      .then(res => {
        next(vm => vm.setData(res));
      })
      .catch(err => console.log(err));
  },
  methods: {
    setData(members) {
      if (members.status == 404) {
        this.$router.push("/");
      } else if (members.status == 403) {
        this.inactive = true;
        this.inactiveMember = members.data;
      } else {
        this.inactive = false;
        this.members = members.data;
        this.numPages = Math.ceil(this.members.length / this.rowsPerPage);
        for (var i = 0, len = this.members.length; i < len; i++) {
          if (this.members[i].bookNum !== "") {
            this.currentPage = Math.floor(i / this.rowsPerPage) + 1;
            this.activeMemberIndex = (i + 1) % this.rowsPerPage;
            break;
          }
        }
      }
    },
    scrollToId(id) {
      let el = this.$el.querySelector(id);
      let rect = el.getBoundingClientRect();
      window.scrollTo(rect.left, rect.top);
    },
    pagination(currentPage, nrOfPages) {
      var delta = 2,
        range = [],
        rangeWithDots = [],
        l;

      range.push(1);

      if (nrOfPages <= 1) {
        return range;
      }

      for (let i = currentPage - delta; i <= currentPage + delta; i++) {
        if (i < nrOfPages && i > 1) {
          range.push(i);
        }
      }
      range.push(nrOfPages);

      for (let i of range) {
        if (l) {
          if (i - l === 2) {
            rangeWithDots.push(l + 1);
          } else if (i - l !== 1) {
            rangeWithDots.push("...");
          }
        }
        rangeWithDots.push(i);
        l = i;
      }

      return rangeWithDots;
    }
  }
};
</script>

<style scoped>
table {
  width: 100%;
}
.pagination-buttons {
  margin-top: 70px;
}
.pagination-buttons a {
  color: #1e87f0;
  font-size: 18px;
}
</style>


// WEBPACK FOOTER //
// src/components/member_queue.vue